import { render, staticRenderFns } from "./EditCampaignModal.vue?vue&type=template&id=35f8a536&scoped=true&"
import script from "./EditCampaignModal.vue?vue&type=script&lang=js&"
export * from "./EditCampaignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f8a536",
  null
  
)

export default component.exports